import useOnboardingContext from '@/hooks/useOnboardingContext';

import LawZipHeader from './law-zip';
import MaxFitHeader from './max-fit';
import PetSitterHeader from './pet-sitter';
import ShampooConditionerHeader from './shampoo-conditioner';
import SpaHeader from './spa';

const HEADER_MAP = {
  'Law Zip': LawZipHeader,
  'Max Fit': MaxFitHeader,
  'PetSitter': PetSitterHeader,
  'Shampoo Conditioner': ShampooConditionerHeader,
  /** v2 package name */
  'Men Spa': SpaHeader,
  /** playful v1 in templateConfig uses `name: "Spa"` with local Spa hero */
  Spa: SpaHeader,
};

const Header = (props) => {
  const { selectedTemplate } = useOnboardingContext();
  
  const MappedHeader = HEADER_MAP[selectedTemplate?.name];

  if (!MappedHeader) {
    return null;
  }

  return <MappedHeader {...props} />;
}

export default Header;
